import { useState } from 'react';
import EmailCheckPasswordForm from './email/EmailCheckPasswordForm';
import EmailCheckCodeForm from './email/EmailCheckCodeForm';
import EmailNewForm from './email/EmailNewForm';

export default function EditEmailDialog({ close }) {
  const [step, setStep] = useState(1);
  const [newEmail, setNewEmail] = useState('');

  return (
    <>
      {step === 1 && <EmailCheckPasswordForm setStep={setStep} />}
      {step === 2 && <EmailCheckCodeForm setStep={setStep} isNew={false} />}
      {step === 3 && (
        <EmailNewForm setStep={setStep} setNewEmail={setNewEmail} />
      )}
      {step === 4 && (
        <EmailCheckCodeForm isNew newEmail={newEmail} close={close} />
      )}
    </>
  );
}
